import { STAKED_VALENTINES_KEY } from "@component/web3-provider/consts";
import { Web3 } from "./web3";

export const updateStakedInLocalStorage = (selectedIds: number[], revealAt: number): void => {
  const stakedJSON = localStorage.getItem(STAKED_VALENTINES_KEY);

  const stakedData = stakedJSON !== null ? JSON.parse(stakedJSON) : {};
  const updatedData = { ...stakedData, [Web3.account.toLowerCase()]: `${selectedIds.join(',')}.${revealAt}` }
  localStorage.setItem(STAKED_VALENTINES_KEY, JSON.stringify(updatedData));
};